<script setup lang="ts">
import { onMounted, onUnmounted } from 'vue';
import { useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';
import Error from '@/components/Error.vue';
import { useWarehouseInfo } from '@/composables/useWarehouseInfo';
import { CheckoutFlowStep, useCheckoutFlow } from '@/composables/useCheckoutFlow';
import { useCountdown } from '@/composables/useCountdown';

const { warehouseData } = useWarehouseInfo();
const { setNextStep } = useCheckoutFlow();
const router = useRouter();
const { t } = useI18n();

const handleFinalizeCheckout = () => {
  setNextStep(CheckoutFlowStep.WelcomePage);
  router.push({
    name: 'checkout-flow',
    query: { warehouseId: warehouseData.value?.id }
  });
};

const { initializeTimer, stopTimer, secondsRemaining } = useCountdown(15, handleFinalizeCheckout);

onMounted(() => {
  initializeTimer();
});

onUnmounted(() => {
  stopTimer();
});
</script>

<template>
  <div class="fill-height d-flex flex-column gap-6 pt-4">
    <div class="d-flex flex-column gap-4 mt-6 px-4 flex-grow-1">
      <error
        :icon="'mdi-alert-circle'"
        :title="t('bolErrorPage.title')"
        :message="warehouseData?.settings?.checkoutBolNotLoadingErrorMessage as string"
        :translate-message="true" />

      <div class="pa-4 juno-i18n-exclude">
        <v-btn block color="primary" @click="handleFinalizeCheckout">
          {{ t('common.actions.finalizeWithCountdown', { seconds: secondsRemaining }) }}
        </v-btn>
      </div>
    </div>
  </div>
</template>
